var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemList',{attrs:{"list-mode":_vm.listMode,"wrap-items":_vm.wrapItems,"read-only":_vm.readOnly},model:{value:(_vm.tags),callback:function ($$v) {_vm.tags=$$v},expression:"tags"}})}
var staticRenderFns = []

export { render, staticRenderFns }